import create from 'zustand'
import verifyWithApple from '../../networks/VerifyWithApple';

const verifyWithAppleStore = create((set, get) => {

  const setErrorAction = (isError, msg) => set({
    hasError: isError,
    errorMessage: msg
  })

  const verifyAction = async (code) => {
    try {
      set({ isLoading: true })
      const response = await verifyWithApple(code)
      set({ 
        result: response.data,
        isLoading: false,
      })
    } catch (error) {
      set({ isLoading: false })
      setErrorAction(true, error.response?.data?.message || error.message);
    }
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    result: null,
    isLoading: false,
    hasError: false,
    errorMessage: '',
  }
  
  return {
    ...initState,
    setError: setErrorAction,
    verify: verifyAction,
    clearAll: clearAllAction,
  }
});

export default verifyWithAppleStore;